// app/components/OrganizationSchema.tsx

interface OrganizationSchemaProps {
  name: string;
  url: string;
  logo: string;
  description?: string;
  email?: string;
  telephone?: string;
  sameAs?: string[];
  address?: {
    streetAddress: string;
    addressLocality: string;
    addressRegion: string;
    postalCode: string;
    addressCountry: string;
  };
  foundingDate?: string;
}

export function OrganizationSchema({ name, url, logo, description, email, telephone, sameAs, address, foundingDate }: OrganizationSchemaProps) {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name,
    url,
    logo: {
      "@type": "ImageObject",
      url: logo,
    },
    ...(description && { description }),
    ...(email && { email }),
    ...(telephone && { telephone }),
    ...(foundingDate && { foundingDate }),
    ...(sameAs && { sameAs }),
    ...(address && {
      address: {
        "@type": "PostalAddress",
        ...address,
      },
    }),
  };

  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />;
}
